@if (!from && !to && !isFormRangeFrom && !isFormRangeTo) {
  <form [formGroup]="mform">
    <input
      formControlName="{{ formControlName }}"
      autocomplete="off"
      class="{{ class }}"
      i18n-placeholder
      placeholder="Select a date"
      name="dp"
      [minDate]="minDate"
      [startDate]="startDate"
      [(appValidateDate)]="model"
      [(ngModel)]="model"
      [displayMonths]="deviceDetector.displayMonths"
      [navigation]="'arrows'"
      container="body"
      ngbDatepicker
      #dp
      #d="ngbDatepicker"
      (click)="d.toggle()"
      tabindex="0"
      id="{{ componentId }}"
      [disabled]="disabled"
      [maxDate]="maxDate"
      [required]="required"
      (dateSelect)="dateSelect($event)"
      firstDayOfWeek="7"
    />
  </form>
}
@if (from || to || isFormRangeFrom || isFormRangeTo) {
  <input
    autocomplete="off"
    class="{{ class }}"
    i18n-placeholder
    placeholder="Select a date"
    name="dp"
    [minDate]="minDate"
    [startDate]="startDate"
    [(ngModel)]="model"
    [displayMonths]="deviceDetector.displayMonths"
    [navigation]="'arrows'"
    container="body"
    ngbDatepicker
    #dp
    #d="ngbDatepicker"
    (click)="d.toggle()"
    tabindex="0"
    id="{{ componentId }}"
    [disabled]="disabled"
    [maxDate]="maxDate"
    [required]="required"
    (dateSelect)="onDateSelection($event, d)"
    [dayTemplate]="t"
    firstDayOfWeek="7"
    autoClose="outside"
    (blur)="emit(model)"
  />
  <ng-template #t let-date let-focused="focused">
    <span
      class="custom-day btn-light"
      [class.focused]="focused"
      [class.range]="isRange(date)"
      [class.faded]="isHovered(date) || isInside(date)"
      [class.left]="isFrom(date)"
      [class.right]="isTo(date) || (from && !to && isHovered(date))"
      (mouseenter)="hoveredDate = date"
      (mouseleave)="hoveredDate = null"
    >
      {{ date.day }}
    </span>
  </ng-template>
}
